import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/68e5b4875ddb6b61d2024765f5724835.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 py-32 md:py-40">
        <div className="max-w-2xl">
          {/* Company Name Badge */}
          <div
            className={`inline-flex items-center gap-2 mb-6 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: '0ms' }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/380df72c-04f1-4058-977d-fe15772f1a53.png"
              alt="MELTI SRL"
              className="h-10 w-auto object-contain"
            />
            <span className="text-white/70 text-xs tracking-[0.3em] uppercase font-400">
              MELTI SRL
            </span>
          </div>

          {/* Main Heading */}
          <h1
            className={`text-white mb-6 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 900,
              fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
              lineHeight: 1.1,
              transitionDelay: '150ms',
            }}
          >
            Modern iOS
            <br />
            <em style={{ fontStyle: 'italic', color: '#e5e5e5' }}>Applications</em>
            <br />
            for Everyone
          </h1>

          {/* Sub-text */}
          <p
            className={`text-white/65 text-base md:text-lg font-300 leading-relaxed max-w-lg transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '300ms', fontWeight: 300 }}
          >
            A team of experts developing modern applications for the iOS platform. Our
            products are designed to enhance user experience and improve the security
            of mobile devices.
          </p>


        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg"></i>
      </div>
    </section>
  );
}
